// source: livongo/protobuf/grpc/external/enrollment/common/question_ids.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} */ (reader.readEnum());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values = {
  UNKNOWN: 0,
  EVER_HAD_A1C: 1,
  A1C_LAST_CHECKED_VALUE: 2,
  A1C_LAST_CHECKED_DATE: 3,
  ADDRESS_LINE1: 4,
  ADDRESS_LINE2: 5,
  BIRTH_DATE: 6,
  BLOOD_PRESSURE_RANGE: 7,
  BP_CHECKS_SELF_REPORTED: 8,
  CGM: 9,
  CITY: 10,
  COUNTRY: 11,
  CURRENT_ACTIVITY_LEVEL: 12,
  DAILY_BGCHECKS: 13,
  DAILY_BGCHECKS_SELF_REPORTED: 14,
  DIABETES_DIAGNOSIS_DATE: 15,
  DIABETES_MANAGEMENT: 16,
  DIABETES_TYPE: 17,
  EATING_HABITS_PAST_WEEK: 18,
  EMAIL: 19,
  FIRST_NAME: 21,
  FLU_VACCINE: 22,
  GENDER: 24,
  HEIGHT: 25,
  HYPERTENSION_DIAGNOSIS_DATE: 26,
  HYPERTENSION_MEDS: 27,
  DIABETES_MEDS: 28,
  INSULIN_PUMP: 29,
  INSURER_CODE: 30,
  INSURER_NAME: 31,
  LAST_NAME: 32,
  LDL_CHOLESTEROL_RANGE: 33,
  LEARN_ABOUT_DIET_PRIORITY: 34,
  MEDICAL_RECORD_NUMBER: 35,
  PASSWORD: 37,
  PHARMACY_MEMBER_ID: 38,
  PHARMACY_GROUP_ID: 39,
  PHONE_HOME: 40,
  PHONE_MOBILE: 41,
  PNEUMONIA_VACCINE: 42,
  POLICY_HOLDER_BIRTH_DATE: 43,
  POLICY_HOLDER_FIRST_NAME: 44,
  POLICY_HOLDER_GROUP_ID: 45,
  POLICY_HOLDER_LAST_NAME: 46,
  POLICY_HOLDER_MEMBER_ID: 47,
  POLICY_HOLDER_NAME: 48,
  POLICY_HOLDER_RELATIONSHIP: 49,
  RACE: 50,
  ETHNICITY: 51,
  SMOKER: 52,
  SSN4: 53,
  STATE: 54,
  USER_ADDRESS_TYPE: 55,
  LIFESTYLE_CHANGE_DESIRED: 56,
  WEIGHT: 57,
  ZIP: 58,
  MOUNTSINAI_DIABETES_ALLIANCE: 59,
  MOUNTSINAI_ER_DATA: 60,
  DIGNITY_HEALTH_TOU: 61,
  UMASS_BG_DATA: 62,
  LOCAL99_TOU: 63,
  LOCATION: 64,
  LIVONGO_POINT_OF_CONTACT: 66,
  EMPLOYEE_ID: 67,
  ARE_YOU_PREGNANT: 68,
  EVER_DIAGNOSED_WITH_DIABETES: 69,
  EVER_DIAGNOSED_WITH_PRE_DIABETES: 70,
  BLOOD_TEST_PREDIABETES: 71,
  RELATIVE_HAS_DIABETES: 72,
  EVER_DIAGNOSED_WITH_GESTATIONAL_DB: 73,
  EVER_DIAGNOSED_WITH_HYPERTENSION: 74,
  ARE_YOU_ACTIVE: 75,
  GOT_SMART_PHONE: 76,
  CONSENT_LABS_DATA_ACCESS: 77,
  EDUCATION: 78,
  SMS_OPT_IN: 79,
  LANGUAGE: 80,
  EVER_HAD_VISUAL_IMPAIRMENT: 81,
  VISUAL_IMPAIRMENT_TYPE: 82,
  PREFER_TO_USE_VOICE_ASSISTANT: 83,
  LIVONGO_BETA_OPT_IN: 84,
  REG_CODE: 85,
  TERMS_AND_CONDITIONS: 86,
  ADDRESS_USA_STANDARD: 87,
  PROGRAM: 88,
  TRACKING_UUID: 89,
  CLIENT_NAME: 90,
  SUPPORTED_REGION: 91,
  REGISTERING_UNDER_13: 92,
  GUARDIAN_FIRST_NAME: 93,
  GUARDIAN_EMAIL: 94,
  CALCULATED_AGE: 95,
  CALCULATED_IS_U13: 96,
  CALCULATED_IS_U18: 97,
  MOBILE_PHONE_INTERNATIONAL: 98,
  MOBILE_PHONE_COUNTRY: 99,
  ADDRESS_USA_MILITARY: 100,
  ADDRESS_USA_MILITARY_UNIT: 101,
  ADDRESS_USA_MILITARY_ADDRESS_TYPE: 102,
  ADDRESS_USA_MILITARY_STATE: 103,
  ADDRESS_USA_COMBINED: 104,
  ADDRESS_USA_TERRITORIES: 105,
  ADDRESS_USA_TERRITORIES_STATE: 106,
  PARTNER_CODE: 107,
  EXTERNAL_ORG_TYPE: 108,
  EXTERNAL_USER_ID: 109,
  MARKETING_ATTRIBUTION: 110,
  EVER_DIAGNOSED_WITH_CHRONIC_KIDNEY_DISEASE: 111,
  ELIGIBILITY_STATUS: 112,
  MIDDLE_NAME: 113,
  TARGET_PROGRAMS: 114,
  LIVONGO_UUID: 116,
  EVER_DIAGNOSED_WITH_HEART_FAILURE: 117,
  EVER_HOSPITALIZED_FOR_HEART_FAILURE: 118,
  HEART_FAILURE_HOSPITALIZATIONS_PAST_YEAR: 119,
  CARDIAC_EJECTION_FRACTION: 120,
  HAS_REPORTED_COPD: 121,
  HAS_REPORTED_KIDNEY_ISSUES: 122,
  HAS_REPORTED_DEPRESSION: 123,
  HAS_REPORTED_HEART_ISSUES: 124,
  HAS_REPORTED_ANEMIA: 125,
  HAS_REPORTED_HYPERTENSION: 126,
  HAS_REPORTED_DIABETES: 127,
  HAS_REPORTED_HIGH_CHOLESTEROL: 128,
  HAS_REPORTED_HEALTH_ISSUES: 129,
  DIAGNOSIS_RECENCY: 130,
  HAS_REPORTED_ARRHYTHMIA: 131,
  ACKNOWLEDGED_CHILD_PRIVACY_POLICY: 132,
  ENROLLMENT_SOURCE: 133,
  ENROLLMENT_MOTIVATION: 134,
  GENDER_IDENTITY: 135,
  CALCULATED_ENROLLED_DPP: 136,
  HF_HEALTH_ALERT_CONSENT: 137,
  CLIENT_CONSENT: 138,
  ADDRESS_CANADA_STANDARD: 139,
  CANADA_PROVINCE: 140,
  CANADA_ZIP: 141,
  ADDRESS_SPAIN_STANDARD: 142,
  SPAIN_LOCALITY: 143,
  SPAIN_PROVINCE: 144,
  SPAIN_ZIP: 145,
  A1C_HOME_LAB_KIT_REQUEST: 146,
  CAMPAIGN_ID: 147,
  CONFIRM_ELIGIBILITY_FILE_REG_CODE: 148,
  SHOW_EXPERIMENTAL_WORDING: 149,
  RACE_SELECTION: 150,
  RACE_OTHER: 151,
  GENDER_IDENTITY_SELECTION: 152,
  GENDER_IDENTITY_OTHER: 153,
  CONFIRM_BIRTH_DATE: 154,
  REG_RECOVERY_TOKEN: 155,
  CALCULATED_ENROLLED_ADPP: 156,
  CALCULATED_ENROLLED_CDPC: 157
};

/**
 * optional Values id = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.getId = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.setId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.enrollment.common);
